import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const SHIMMER_CLASSES =
  'animate-[shimmer_1.5s_ease-in-out_infinite] bg-[length:200%_100%] bg-[linear-gradient(90deg,theme(colors.gray.200)_0%,theme(colors.gray.100)_50%,theme(colors.gray.200)_100%)]';
